import PropTypes from 'prop-types';
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog
} from '@mui/material';

import './InformationDialogue.scss';

function InformationDialogue({ title, confirmLabel, onClose, open, children }) {

  const handleEntering = () => {};

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog
      className="information-dialogue"
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
    >
      {title && (
        <DialogTitle className="dialogue-title">{title}</DialogTitle>
      )}
      <DialogContent dividers>
        {children}
      </DialogContent>
      <DialogActions className="dialogue-actions">
        <Button onClick={handleOk}>{confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}

InformationDialogue.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default InformationDialogue;
